import React, { useCallback, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

import { selectCustomStyles } from "../../../../lib/constants";
import { api } from "../../../../utils/axios/Config";
import { cn } from "../../../../utils/utils";

// Memoized version of the component
const SelectBankAccounts = React.memo(
  (props) => {
    const { control, label, name, className, errors, disabled } = props;
    const [options, setOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
      fetchOptions();
    }, [searchQuery]);

    const fetchOptions = useCallback(async () => {
      try {
        const response = await api.get(`/accounts/?active_status=true`);
        const fetchedOptions = response.data.items.map((item) => ({
          value: item?.account?.iban,
          iban: item?.account?.iban,
          label: item?.account?.name,
          id: item?.account?.id,
        }));
        setOptions(fetchedOptions);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    }, []);

    const handleInputChange = useCallback((newValue) => {
      const query = newValue;
      setSearchQuery(query);
      return query;
    }, []);

    const CustomComponent = (props) => {
      const { innerRef, innerProps, data, isSelected } = props;

      return (
        <div
          ref={innerRef}
          {...innerProps}
          className={`p-2 hover:bg-neutral-20 cursor-pointer ${isSelected ? "bg-neutral-20" : ""}`}
        >
          <div className="font-semibold">{data.label}</div>
          <div className="text-sm text-neutral-50">{data.iban}</div>
          <hr />
        </div>
      );
    };

    return (
      <div className={cn("col-span-2 xl:col-span-1 flex flex-col gap-2 ", className)}>
        <label htmlFor={name}>{label}</label>
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, onBlur, value, ref } }) => {
            //console.log(options)
            const selected = options.find((option) => option.id === value);
            //console.log(selected,value,"value")
            return (
              <Select
                styles={selectCustomStyles}
                value={options.find((option) => option.id === value)}
                options={options}
                isDisabled={disabled}
                onInputChange={handleInputChange}
                components={{ Option: CustomComponent }}
                onChange={(selectedOption) => {
                  onChange(selectedOption ? selectedOption.id : null);
                }}
                placeholder="جستجو..."
                isClearable={true}
                noOptionsMessage={() => "موردی یافت نشد ..."}
              />
            );
          }}
        />

        {errors?.message && <div className="text-red-500  text-sm">{errors?.message}</div>}
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Prevents re-render if props haven't changed
    return (
      prevProps.control === nextProps.control &&
      prevProps.label === nextProps.label &&
      prevProps.name === nextProps.name &&
      prevProps.className === nextProps.className &&
      prevProps.errors === nextProps.errors &&
      prevProps.disabled === nextProps.disabled
    );
  },
);

export default SelectBankAccounts;

// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import {api} from "../../../../utils/axios/Config";
// import { selectCustomStyles } from "../../../../lib/constants";
// import { Controller } from "react-hook-form";
// import { cn } from "../../../../utils/utils";
// import Loader from "../../../shared/Loader";

// const SelectBankAccounts = (props) => {
//   const { control, label, name, className, errors, disabled } = props;

//   const [options, setOptions] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchOptions();
//   }, [disabled]); // Adding disabled to dependencies if it affects data fetching

//   const fetchOptions = async () => {
//     try {
//       const response = await api.get(`/accounts/?active_status=true`);
//       const fetchedOptions = response.data.items.map((item) => ({
//         value: item?.account?.iban,
//         iban: item?.account?.iban,
//         label: item?.account?.name,
//         id: item?.account?.id,
//       }));
//       setOptions(fetchedOptions);
//       setIsLoading(false);
//     } catch (error) {
//       console.error("Error fetching options:", error);
//       setError("Error loading bank accounts.");
//       setIsLoading(false);
//     }
//   };

//   const CustomComponent = ({ innerRef, innerProps, data, isSelected }) => (
//     <div
//       ref={innerRef}
//       {...innerProps}
//       className={`p-2 hover:bg-neutral-20 cursor-pointer ${
//         isSelected ? "bg-neutral-20" : ""
//       }`}
//     >
//       <div className="font-semibold">{data.label}</div>
//       <div className="text-sm text-neutral-50">{data.iban}</div>
//       <hr />
//     </div>
//   );

//   return (
//     <div
//       className={cn("col-span-1 xl:col-span-1 flex flex-col gap-2", className)}
//     >
//       <label htmlFor={name}>{label}</label>
//       <Controller
//         control={control}
//         name={name}
//         render={({ field }) => (
//           <>
//             {isLoading ? (

//                 <Loader />

//             ) : error ? (
//               <p className="text-red-500">{error}</p>
//             ) : (
//               <Select
//                 styles={selectCustomStyles}
//                 value={
//                   options.find((option) => option.id === field.value) || null
//                 }
//                 options={options}
//                 isDisabled={disabled || isLoading} // Disable if loading or prop disabled
//                 components={{ Option: CustomComponent }}
//                 onChange={(selectedOption) => {
//                   //console.log(selectedOption, "selectedOption");
//                   field.onChange(selectedOption ? selectedOption.id : null);
//                 }}
//                 placeholder="جستجو..."
//                 noOptionsMessage={() => "موردی یافت نشد ..."}
//                 ref={field.ref}
//                 onBlur={field.onBlur}
//               />
//             )}
//           </>
//         )}
//       />
//       {errors?.message && (
//         <div className="text-red-500 text-sm">{errors?.message}</div>
//       )}
//     </div>
//   );
// };

// export default SelectBankAccounts;
